export default {
  'STOCK': 'Securities Account',
  'FUTURES': 'Futures Account',
  'FOREX': 'Foreign Exchange Account',
  'IB': 'EddidPro Account',
  'PM': 'Spot Gold Account',
  'accountInfo': 'Account Information',
  'transId': 'Transaction Number',
  'search': 'Search',
  'export': 'Export',
  'clientAccount': 'Client Account Number',
  'transDate': 'Trading Date',
  'valueDate': 'Settlement Date',
  'productName': 'Product Name',
  'number': 'Quantity',
  'tranAmount': 'Trading Amount',
  'commission': 'Commission',
  'market': 'Market',
  'orderType': 'Order Type',
  'avgPrice': 'Buy/Sell price',
  'selectStartTime': 'Please select start date',
  'selectEndTime': 'Please select end date',
  'selectTimeError': 'End time shall not be less than start time',
  'B': 'Buy',
  'S': 'Sell',
  'noData': 'No trading record'
}
